import { useEffect, useState } from "react";
import InputForm from "../riutilizabili/forms/InputForm";
import PaginazioneTitoloPulsanteCrea from "../riutilizabili/PaginazioneTitoloPulsanteCrea";
import PulsantiFiltra from "../riutilizabili/PulsantiFiltra";
import seriali_fetch from "../fetch/seriali_fetch";
import TabellaPaginazione from "../riutilizabili/TabellaPaginazione";
import { format } from "date-fns";
import InfoModal from "../riutilizabili/InfoModal";
import ReadCampiBolla from "../bolla/sezioni/ReadCampiBolla";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faFileLines } from "@fortawesome/free-solid-svg-icons";
import bolla_fetch from "../fetch/bolla_fetch";
import create_autocompleteWithService from "../riutilizabili/autocomplite/create_autocompleteWithService";
import classSezione from "../fetch/classSezione";
import Switch from "../riutilizabili/forms/Switch";
import RadiusForm from "../riutilizabili/forms/RadiusForm";



export default function ViewSeriali() {
    const [inputFiltra, setInputFiltra] = useState({})
    const [dati, setDati] = useState(false)

    const [viewBolla , setViewBolla] = useState(false);
    const [viewBollaUscita , setViewBollaUscita] = useState(false);

    const onChange = (nome,valore) => {
        let tmp = {...inputFiltra}
        if (valore === '') {
            delete tmp[nome]
        }else {
            tmp[nome] = valore
        }
        setInputFiltra(tmp)
        //filtra(tmp)
    }

    const filtra = async (param) =>  {
       //console.log(param ,' param');
        
        if (Object.keys(param).length === 0 ) {
            setDati(false)
            return
            
        }
        if (!param?.rifInterno && !param?.seriale && !param?.provisioning) {
            setDati(false)
            return
        }
        const test = await seriali_fetch.controllaSeriali(param)
        setDati(test.data) 
    }

    const azzera = () => {
        setInputFiltra({})
        setDati(false)
    }
    
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const rifInterno = params.get('rifInterno');
        if (rifInterno) {
            setInputFiltra({ rifInterno });
            filtra({ rifInterno });
        }
    }, []);

    const convertiData = (data) => {
        //console.log(format(new Date(data) ,'dd-MM-yyyy hh:mm') , ' Date ' , data);
        //console.log(data ,' Date 2' , (data+'').indexOf('Z'));
        if ((data+'').indexOf('Z') !== -1) {
            return format(new Date(data) ,'dd-MM-yyyy hh:mm') 
        }
        return format(new Date(data) ,'dd-MM-yyyy') 
}

    const readViewBolla = async (bollaId) => {
        const bolla = await bolla_fetch.get({id : bollaId})
       //console.log(bolla.data[0] ,' bolla');
        
        setViewBolla(bolla.data[0])
    }

        const readBollaView = async (bollaId) => {
            const array = await bolla_fetch.getBollaUscita({id : bollaId});
           //console.log(array.data[0], ' array.data[0]');
            
            setViewBolla({...array.data[0] , numero : array.data[0].id+'/'+array.data[0].annoId+(!!array.data[0].codiceMag ? ' - '+array.data[0].codiceMag : '')})
        }


    const colonne = [
        {
            id: 1,
            label: 'Seriale',
            nome: 'seriale',

        },
        {
            id: 1,
            label: 'Provisioning',
            nome: 'provisioning',

        },
        {
            id: 3,
            label: 'Codice interno',
            nome: 'rifInterno',
            altCol : (item)=> {
                return(
                    <div style={{width: '10rem'}} className='m-auto' >
                            {item.Prod_posizione_sezione.rifInterno}
                    </div>
                )
            }
        },
        {
            id: 3,
            label: 'Magazzino',
            nome: 'magazzino',
            altCol : (item)=> {
                return(
                    <div style={{width: '10rem'}} className='m-auto' >
                        {item.Prod_posizione_sezione.infoSezione?.nome}
                    </div>
                )
            }
        },
        {
            id: 1,
            label: 'Tipo DDT',
            nome: 'tipo',
            altCol : (item)=> {
                return(
                    <div style={{width: '10rem'}} className='m-auto' >
                        {item.Prod_posizione_sezione.bollaEntrata === null ? 'DDT in uscita' : 'DDT in entrata'}
                    </div>
                )
            }
        },
        {
            id: 2,
            label: 'DDT',
            nome: 'DDT',
            altCol : (item)=> {
                return(
                    <div style={{width: '10rem'}} className='m-auto' >
                        {item.Prod_posizione_sezione.bollaEntrata === null ? 
                            <button onClick={()=>readBollaView(item.Prod_posizione_sezione.bollaUscita.id)} className="btn py-0 my-0 pb-1">
                                {item.Prod_posizione_sezione.bollaUscita.idProg+'/'+item.Prod_posizione_sezione.bollaUscita.annoId+(item.Prod_posizione_sezione.bollaUscita.codiceMag === null ? '' : '-'+item.Prod_posizione_sezione.bollaUscita.codiceMag)}
                                <FontAwesomeIcon icon={faEye} className="ms-4" />
                            </button>
                        : 
                        <button onClick={()=>readViewBolla(item.Prod_posizione_sezione.bollaEntrata.id)} className="btn py-0 my-0 pb-1">
                            {item.Prod_posizione_sezione.bollaEntrata.numero}
                                <FontAwesomeIcon icon={faEye} className="ms-4" />
                        </button>
                        }
                    </div>
                )
            }
        },
        {
            id: 4,
            label: 'Data e ora',
            nome: 'dataCreate',
            altCol : (item)=> {
                return(
                    <div style={{width: '10rem'}} className='m-auto' >
                        {format(item.dataCreate, "dd-MM-yyyy HH:mm")}
                    </div>
                )
            }
        }
    ]

    const onChangeMagazzino = async ({ value, item }) => {
        setInputFiltra({...inputFiltra, magazzinoNome: item?.nome || null , magazzinoId: item?.id || null})
        if (!inputFiltra?.rifInterno && !inputFiltra?.seriale && !inputFiltra?.provisioning && !item?.id) {
            setInputFiltra({})
            setDati(false)
            return
            
        }

        if (inputFiltra?.riferimento || inputFiltra?.seriale || inputFiltra?.provisioning) {
            await filtra({...inputFiltra, magazzinoNome: item?.nome , magazzinoId: item?.id})
        }
    }

    const AutocompleteMagazzino = create_autocompleteWithService({
        freeinput: false,
        service: (myValue, serviceValues) => classSezione.get({
            magazzinoPrincipale :1 ,
            nome: myValue,
            ...serviceValues,
            autoComplite: 1
        }),
        itemCompare: (item, inputValue) => item.nome.toLowerCase().indexOf((inputValue || "").toLowerCase()) !== -1,
        itemToLi: item => item.nome ,
        itemToString: item => item.nome,
        itemFind: (value, items) => items.reduce((acc, curr) => acc || (curr.nome.toLowerCase() === value.toLowerCase() ? curr : null), null),
        label: 'Seleziona magazzino',
        placeholder: 'inserisci magazzino',
        onChange: onChangeMagazzino,
        value: inputFiltra?.magazzinoNome,
        className : ' mb-0 '
    });

    const onChangeTipoDDT = (nome , valore) => {
        let tmp = {...inputFiltra}
        switch (valore) {
            case 1:
                delete tmp.tipoDDT
                delete tmp.soloDDTUscita
                delete tmp.soloDDTEntrata
            break;
            case 2:
                tmp.soloDDTEntrata = 1
                delete tmp.soloDDTUscita
            break;
            case 3:
                tmp.soloDDTUscita = 1
                delete tmp.soloDDTEntrata
            break;
        
        }
        tmp.tipoDDT = valore
        setInputFiltra(tmp)
        filtra(tmp)
    }

    return(
        <div className="pt-2">
            <PaginazioneTitoloPulsanteCrea titolo={'Seriali'} funCrea={null} />
            <div className="p-4 ps-5">
                <div className='border_filtra p-3 mx-4 px-4 d-flex flex-wrap' >
                    <InputForm
                        type={'text'}
                        name={'rifInterno'}
                        placeholder={'Inserisci codice interno'}
                        label={'codice interno'}
                        classi={' col-3 '}
                        value={inputFiltra?.rifInterno || ''}
                        onChange={onChange}
                        errors={{}}
                    />
                    <InputForm
                        type={'text'}
                        name={'seriale'}
                        placeholder={'Inserisci seriale'}
                        label={'Seriale'}
                        classi={' col-3 '}
                        value={inputFiltra?.seriale || ''}
                        onChange={onChange}
                        errors={{}}
                    />

                    <InputForm
                        type={'text'}
                        name={'provisioning'}
                        placeholder={'Inserisci provisioning'}
                        label={'Provisioning'}
                        classi={' col-3 '}
                        value={inputFiltra?.provisioning || ''}
                        onChange={onChange}
                        errors={{}}
                    />
                    <div className="pt-3 me-3 col-3">
                        <AutocompleteMagazzino />
                    </div>

                    <RadiusForm
                        label={' '}
                        arrayElement={[{label: 'Tutti', valore: 1}, {label: 'Solo DDT in entrata', valore: 2},  {label: 'Solo DDT in uscita', valore: 3}]}
                        name={'tipoDDT'}
                        value={inputFiltra?.tipoDDT || 1}
                        onChange={onChangeTipoDDT}
                        classi={' pt-4 '}
                    />
                    
                    <div className="ps-2 col-12">
                        <PulsantiFiltra azzera={azzera} filtra={()=>filtra(inputFiltra)}  />
                    </div>
                </div>
                <div className="p-3 pt-5 pe-4">
                    {dati ?<TabellaPaginazione
                        colonne={colonne}
                        dati={dati}
                        impaginazione={null}
                    />
                    : <div className='text-center mt-5'></div>
                    }
                </div>

            </div>

            {!!viewBolla && 
                <InfoModal
                    size='xl'
                    title={'Ddt n° ' +viewBolla.numero}
                    text={
                        <ReadCampiBolla inputs={viewBolla} infoAddView={false}/>
                    }
                    canClose
                    handleClose={()=>setViewBolla(false)}
                    className = 'modal-lg'
                />
            }

            {!!viewBollaUscita && 
                <InfoModal
                    title={ 
                    <h3 className="text-white d-flex align-items-center ps-3" >
                        <FontAwesomeIcon className="me-3 text-white" icon={faFileLines} />
                        DDT N° { viewBollaUscita?.id+'/'+viewBollaUscita?.annoId+(!!viewBollaUscita?.codiceMag ? ' - '+viewBollaUscita.codiceMag : '') + ' del ' +convertiData(viewBollaUscita?.dataFattura) }
                    </h3>
                    }
                    text={
                        <ReadCampiBolla inputs={viewBollaUscita} cliente={true} />
                    }
                    canClose
                    handleClose={()=>setViewBollaUscita(false)}
                    classi=' modal-xxl '
                />
            }
        </div>
    )
}